import React from 'react';
import { SkeletonItemsList } from './Skeleton.items.list';
export const SkeletonFacet = () => (React.createElement("div", { style: { paddingBottom: '1.4375em' } },
    React.createElement("div", { className: "skeleton bdrs:2", style: { paddingBottom: '1.375em', height: '3.125em' } }),
    React.createElement(SkeletonItemsList, null)));
